import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { AxiosResponse } from "axios";
import { IPackage, ISticker } from "./types/_sticker";

const api = new APIClient();

const path = "/sticker-packages";
const pathSticker = "/stickers";

const stickerApi = {
  packageStickers(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getPackageSticker(id: string | number, params: any = {}) : Promise<AxiosResponse<ResponseData<IPackage>, any>>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },

  postPackageSticker(dataForm: any) : Promise<AxiosResponse<ResponseData<IPackage>, any>>  {
    const url = `${path}`;
    return api.post(url, dataForm)
  },

  putPackageSticker(id: string | number, dataForm: any) : Promise<AxiosResponse<ResponseData<IPackage>, any>>  {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },

  deletePackageSticker(id: any) {
    return api.delete(`${path}/${id}`);
  },
  
  getStickers(params: any = {}) : Promise<AxiosResponse<ResponseData<ISticker>, any>>  {
    const url = `${pathSticker}`;
    return api.get(url, params)
  },

  getSticker(id: string | number, params: any = {}) : Promise<AxiosResponse<ResponseData<ISticker>, any>>  {
    const url = `${pathSticker}/${id}`;
    return api.get(url, params)
  },

  postSticker(dataForm: any) : Promise<AxiosResponse<ResponseData<ISticker>, any>>  {
    const url = `${pathSticker}`;
    return api.post(url, dataForm)
  },

  putSticker(id: string | number, dataForm: any) : Promise<AxiosResponse<ResponseData<ISticker>, any>>  {
    const url = `${pathSticker}/${id}`;
    return api.put(url, dataForm)
  },

  deleteSticker(id: any) {
    return api.delete(`${pathSticker}/${id}`);
  },
};

export default stickerApi;
